/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './svg-icon.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/shared/svg-icon/svg-icon.component';
const styles_SvgIconComponent:any[] = [i0.styles];
export const RenderType_SvgIconComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_SvgIconComponent,data:{}});
export function View_SvgIconComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,':svg:svg',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),0,':svg:use',([] as any[]),[[1,':xlink:href',
          0]],(null as any),(null as any),(null as any),(null as any)))],(null as any),
      (_ck,_v) => {
        var _co:i2.SvgIconComponent = _v.component;
        const currVal_0:any = _co.path;
        _ck(_v,1,0,currVal_0);
      });
}
export function View_SvgIconComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'svg-icon',([] as any[]),
      (null as any),(null as any),(null as any),View_SvgIconComponent_0,RenderType_SvgIconComponent)),
      i1.ɵdid(114688,(null as any),0,i2.SvgIconComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const SvgIconComponentNgFactory:i1.ComponentFactory<i2.SvgIconComponent> = i1.ɵccf('svg-icon',
    i2.SvgIconComponent,View_SvgIconComponent_Host_0,{name:'name'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvc3ZnLWljb24vc3ZnLWljb24uY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L3dhbXA2NC93d3cvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL3N2Zy1pY29uL3N2Zy1pY29uLmNvbXBvbmVudC50cyIsIm5nOi8vL0U6L3dhbXA2NC93d3cvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL3N2Zy1pY29uL3N2Zy1pY29uLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvc3ZnLWljb24vc3ZnLWljb24uY29tcG9uZW50LnRzLlN2Z0ljb25Db21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c3ZnPjx1c2UgW2F0dHIueGxpbms6aHJlZl09XCJwYXRoXCI+PC91c2U+PC9zdmc+IiwiPHN2Zy1pY29uPjwvc3ZnLWljb24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQUs7YUFBQTtVQUFBOzs7UUFBSztRQUFMLFdBQUssU0FBTDs7OztvQkNBTDtNQUFBO2FBQUE7VUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/shared/svg-icon/svg-icon.component.ngfactory.ts